import { 
   getDefaultValueLoading, 
   getDefaultValueSuccess, 
   getDefaultValueFailure,
   updateDefaultValueLoading,
   updateDefaultValueSuccess,
   updateDefaultValueFailure
} from "@redux/slices/defaultValuesSlice.js"
import { getDefaultValues } from "@services/defaultValues/getDefaultValues"
import { updateDefaultValues } from "@services/defaultValues/updateDefaultValues"
import { useDispatch } from "react-redux"

const useDefaultValues = () => {
   const dispatch = useDispatch()

   const handleGetDefaultValues = async (userId, adAccountId=null) => {
      try {
         dispatch(getDefaultValueLoading())
         // console.log("adAccountId", adAccountId)
         const response = await getDefaultValues(userId, adAccountId)
         dispatch(getDefaultValueSuccess(response.data))
      } catch (error) {
         dispatch(getDefaultValueFailure())
         console.log(error)
      }
   }

   const handleUpdateDefaultValues = async (userId, adAccountId=null, data={}) => {
      try {
         dispatch(updateDefaultValueLoading())
         // console.log("adAccountId", adAccountId)
         const response = await updateDefaultValues(userId, data, adAccountId)
         dispatch(updateDefaultValueSuccess(response.data))
         return response.data
      } catch (error) {
         dispatch(updateDefaultValueFailure(error.message))
         throw error
      }
   }

   return { handleGetDefaultValues, handleUpdateDefaultValues }
}

export default useDefaultValues